module.exports = __webpack_public_path__ + "img/weforge.4e0b9d1f.png";